<template>
    <v-card outlined elevation="0" class="d-flex justify-center" style="overflow:hidden">
        <v-select v-model="query['type']" v-bind="{ items }" prefix="상태: " dense flat solo hide-details class="text-caption" style="margin:-1px;width:120px" @change="emit" />
    </v-card>
</template>

<script>
const initQuery = (query = {}) => ({
    ...(query || {}),
    ["type"]: query?.["type"] || "null",
});

const items = [
    { text: "전체", value: "null" },
    { text: "교환", value: "isDone" },
    { text: "충전", value: "cashed" },
    { text: "선물(충전)", value: "gifted-cashed" },
    { text: "선물(대기)", value: "gifted" },
];

export default {
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (query["type"] == "null") delete query["type"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-select__selection.v-select__selection--comma {
        margin: 0 !important;
    }
    .v-input__slot {
        padding-right: 4px !important;
    }
}
</style>
